"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _themeUi = require("theme-ui");

var _Image = _interopRequireDefault(require("../Image/Image"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var CardImage = function CardImage(props) {
  return (0, _themeUi.jsx)(_Image["default"], _extends({}, props, {
    sx: {
      display: 'block',
      width: '100%',
      height: 10
    }
  }));
};

CardImage.propTypes = {
  src: _propTypes["default"].string.isRequired
};
var _default = CardImage;
exports["default"] = _default;